import { render, staticRenderFns } from "./CheckboxNew.vue?vue&type=template&id=15161a4e&scoped=true"
import script from "./CheckboxNew.vue?vue&type=script&lang=js"
export * from "./CheckboxNew.vue?vue&type=script&lang=js"
import style0 from "./CheckboxNew.vue?vue&type=style&index=0&id=15161a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15161a4e",
  null
  
)

export default component.exports